import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSearchProductsById } from 'core/actions/ocapi';
import ProductItem from 'core/modules/ProductItem/ProductItem';
import List from 'core/modules/Partials/List/List';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import {
  selectProductListIsLoaded, selectProductListIsLoading, selectProducts,
} from './selectors';
import configs from './configs';

import './ProductList.scss';

function ProductList({ product_ids: ids, title }) {
  const isLoaded = useSelector(selectProductListIsLoaded);
  const isLoading = useSelector(selectProductListIsLoading);
  const products = useSelector(selectProducts);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const dispatch = useDispatch();
  const { api: { params, options }, carousel } = configs;

  useEffect(() => {
    if (!isLoaded && !isLoading && configs && ids) {
      const combinedParams = { ...params, id: ids };

      dispatch(fetchSearchProductsById(ids, combinedParams, options));
    }
  }, []);

  if (products && products.length) {
    return (
      <div className="mn_productList" data-test="product-list">
        <SectionTitle title={title} />
        <List options={carousel} shouldUseCarousel={isMobileMQ}>
          {products.map(product => (
            <ProductItem product={product} key={product.id} />
          ))}
        </List>
      </div>
    );
  }

  return null;
}

export default ProductList;
